<script setup lang="ts">
import { computed } from 'vue'

import { useAd } from '../../../advertisement/composables/use-ad'
import AdSlot from '../../ad/AdSlot.vue'
import { useCombinedHeightOfTextBlocks } from '../../../content-blocks/composables/use-combined-height-of-text-blocks'
const props = defineProps<{
  id: string
  float?: boolean
  index: number
}>()

const index = computed(() => props.index)
const { slotName, height, status, minWidth, minHeight } = useAd('rectangle', index.value)
const id = computed(() => props.id)
const combinedHeightOfTextBlocks = useCombinedHeightOfTextBlocks(id.value)

const rectangleAdShouldFloat = computed(() => {
  // Calculate if text blocks reach at least 2/3 of ad height
  const textBlocksReachThreshold = Math.ceil(combinedHeightOfTextBlocks.value) >= Math.ceil((2 / 3) * height.value)

  // float if float prop is true (from store) & text-blocks reach at least 2/3 of ad height
  return props.float && textBlocksReachThreshold
})
</script>

<template>
  <AdSlot v-if="slotName && status !== 'failed'"
          :min-width="minWidth"
          :min-height="minHeight"
          :slot-name="slotName"
          :float="rectangleAdShouldFloat" />
</template>
